import PropTypes from 'prop-types';
import styled from 'styled-components';
import Text from '@g4/boneyard/lib/Text';
import { withValue } from '@g4/automation-hooks';
import moment from '@g4/moment-utc';
import React from 'react';
import { useMedia } from '../../../../../components/Boneyard';
import { peacockBlue } from '@g4/boneyard/lib/theme/colors';

const propTypes = {
  automationHook: PropTypes.string,
  month: PropTypes.number.isRequired,
  year: PropTypes.number.isRequired,
};

const HeaderContent = styled(props => {
  const mq = useMedia();
  const isMobile = mq.lte('sm');
  return (
    <h2 className={props.className}>
      <Text
        size={!isMobile ? 25 : 20}
        color={peacockBlue}
        automationHook={withValue(props.automationHook, 'display-month-year')}
      >
        {moment(props.month + 1, 'M').format('MMMM')} {props.year}
      </Text>
    </h2>
  );
})`
  white-space: nowrap;
`;

HeaderContent.propTypes = propTypes;
HeaderContent.displayName = 'Header';

export default props => <HeaderContent {...props} />;
